import { useMemo } from 'react';
import { defineAbilityFor } from 'src/acl/ability';
import { useAuth } from 'src/contexts/AuthContext';

/** NPT-2144 — CASL ability from the user's site roles plus their role in the current org. */
export const useAbility = () => {
   const { user, currentOrganizationId } = useAuth();
   return useMemo(() => defineAbilityFor(user, currentOrganizationId), [user, currentOrganizationId]);
};

/** Platform admins are the only ones who may change schedules, org pages, team hotels and the rest. */
export const useIsPlatformAdmin = () => useAbility().can('manage', 'all');

export default useAbility;
